"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeQuery = exports.timeUnits = void 0;
const moment_1 = __importDefault(require("moment"));
exports.timeUnits = [
    'years',
    'months',
    'weeks',
    'days',
    'hours',
    'minutes',
    'seconds',
    'milliseconds',
    'year',
    'month',
    'week',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond',
    'y',
    'M',
    'w',
    'd',
    'h',
    'ms',
    'm',
    's',
];
exports.DateRangeQuery = {
    checkTimeNumber(timeNumber) {
        if (!timeNumber || (timeNumber && isNaN(Number(timeNumber)))) {
            throw new Error('Query should include a number as the time unit, ex: "last4days" or "1year"');
        }
    },
    getTimeUnitFromQuery(query) {
        var _a;
        const timeUnit = (_a = query.split('last').pop()) === null || _a === void 0 ? void 0 : _a.replace(/[0-9]/g, '');
        return exports.timeUnits.find((tu) => tu === timeUnit);
    },
    getFormatedDate(date, format) {
        if (date) {
            return format ? moment_1.default(date, format).toDate() : moment_1.default(date).toDate();
        }
        else {
            return moment_1.default().toDate();
        }
    },
    // allows single dates
    transformDateInDateArray(query) {
        if (!Array.isArray(query) && moment_1.default(query, moment_1.default.ISO_8601).isValid()) {
            return [query, ''];
        }
    },
    getDates(timeUnit, query, options = {}) {
        var _a, _b;
        if (!query.includes(timeUnit)) {
            return;
        }
        if (!query.includes('last') &&
            ((!options.date_start && !options.date_stop) ||
                (options.date_start && options.date_stop))) {
            throw new Error('Either include "last" as query first word either include date_start OR date_stop (with date format) in the options, ex: DateRangeQuery.queryToDates("last4days") or DateRangeQuery.queryToDates("4days", options: {date_start:"2021-02-28", format: "YYYY-MM-DD"})');
        }
        const timeNumber = (_b = (_a = query.split('last').pop()) === null || _a === void 0 ? void 0 : _a.split(timeUnit)) === null || _b === void 0 ? void 0 : _b.shift();
        exports.DateRangeQuery.checkTimeNumber(timeNumber);
        const dateStart = options.date_start
            ? exports.DateRangeQuery.getFormatedDate(options.date_start, options.format)
            : moment_1.default(exports.DateRangeQuery.getFormatedDate(options.date_stop, options.format))
                .subtract(Number(timeNumber), timeUnit)
                .add(1, 'day')
                .toDate();
        let dateStop = query.includes('last') &&
            moment_1.default(exports.DateRangeQuery.getFormatedDate(moment_1.default().format('YYYY-MM-DD'), options.format)).toDate();
        if (!dateStop) {
            dateStop = options.date_stop
                ? exports.DateRangeQuery.getFormatedDate(options.date_stop, options.format)
                : moment_1.default(exports.DateRangeQuery.getFormatedDate(query.includes('last')
                    ? moment_1.default().format('YYYY-MM-DD')
                    : options.date_start, options.format))
                    .add(Number(timeNumber), timeUnit)
                    .subtract(1, 'day')
                    .toDate();
        }
        return [dateStart, dateStop];
    },
    /**
     * returns an array of Dates per default or an array of strings if a format is passed in the options
     * @param {string} query Query of time range (ex: "last4days" or "10months")
     * @param {object} [options.format] Format of the returning date array (ex: "YYYY-MM-DD")
     * @param {object} [options.date_start] Provide either date_start or date_stop if the query doesn't starts with "last"
     * @param {object} [options.date_stop] Provide either date_start or date_stop if the query doesn't starts with "last"
     * @returns {string[] | Date[]} dates Array of date start and date stop
     */
    queryToDates(query, options) {
        if (Array.isArray(query)) {
            return query;
        }
        if (!query) {
            return [];
        }
        let dates = exports.DateRangeQuery.transformDateInDateArray(query) || [];
        if (dates === null || dates === void 0 ? void 0 : dates.length) {
            return dates;
        }
        const timeUnit = exports.DateRangeQuery.getTimeUnitFromQuery(query);
        if (timeUnit) {
            dates = exports.DateRangeQuery.getDates(timeUnit, query, options) || [];
        }
        else {
            throw new Error(`Make sure your query is one of those unit: ${exports.timeUnits.join(', ')}`);
        }
        if (dates.length === 2 && (options === null || options === void 0 ? void 0 : options.format)) {
            dates = [
                moment_1.default(dates[0]).format(options.format),
                moment_1.default(dates[1]).format(options.format),
            ];
        }
        return dates;
    },
    /**
     * returns a date range query, starts with 'last' if only one date is provided
     * @param {string[] | Date[]} dates Array of date start and date stop
     * @param {unitOfTime.Base} timeUnit Time unit to calculate and finish the query string, can be written like "year" "years" or "y" (ex: "y" with one date from last year will create "last1y")
     * @param {object} [options.format] Format of the provided dates array (ex: "YYYY-MM-DD")
     * @returns {string} query Query string of time range
     */
    datesToQuery(dates, timeUnit) {
        let datesArray = [];
        let query = '';
        if (dates.length > 2 || dates.length < 1) {
            throw new Error('The array must contain between one and two dates');
        }
        for (const date of dates) {
            if (!moment_1.default(date)) {
                throw new Error('The array must contain valid dates, if the date has a specific format, add the format to the options, ex: { format: "YYYY-MM-DD"}');
            }
        }
        if (dates.length === 1) {
            query = 'last';
            datesArray = [
                exports.DateRangeQuery.getFormatedDate(dates[0]),
                exports.DateRangeQuery.getFormatedDate(undefined),
            ];
        }
        else {
            datesArray = [
                exports.DateRangeQuery.getFormatedDate(dates[0]),
                exports.DateRangeQuery.getFormatedDate(dates[1]),
            ];
        }
        query += moment_1.default(datesArray[1]).diff(datesArray[0], timeUnit) + timeUnit;
        return query;
    },
};
